import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: data,
  });
}

export function login_token(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data,
  });
}

export function getInfo() {
  return request({
    url: '/auth/user',
    method: 'get',
  });
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post',
  });
}

export function getMenu() {
  return request({
    url: '/permissions/menuPermission',
    method: 'GET',
  });
}
